import { combineReducers, createReducer } from "@reduxjs/toolkit";
import {
  FETCH_TASK_RESCHEDULE_SIMULATION_SUCCESS,
  RESCHEDULE_TASK_ERROR,
  RESCHEDULE_TASK_SUCCESS,
  CLEAR_RESCHEDULE_SIMULATION,
} from "../action_types";

const initialSimulationState = {};

const tasks = createReducer(initialSimulationState, (builder) => {
  builder
    .addCase(FETCH_TASK_RESCHEDULE_SIMULATION_SUCCESS, (state, action) => {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { reschedule_simulation } = entities;
      return reschedule_simulation ? reschedule_simulation : state;
    })
    .addCase(RESCHEDULE_TASK_ERROR, (state, action) => {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { tasks } = entities;
      return tasks ? tasks : state;
    })
    .addMatcher(
      (action) => [RESCHEDULE_TASK_SUCCESS, CLEAR_RESCHEDULE_SIMULATION].includes(action.type),
      () => {
        return initialSimulationState;
      }
    );
});

const simulationChanged = createReducer(false, (builder) => {
  builder
    .addCase(RESCHEDULE_TASK_ERROR, (state, action) => {
      const { error = {} } = action;
      if (error.status_code === 409) {
        state = true;
      }
      return state;
    })
    .addMatcher(
      (action) =>
        [FETCH_TASK_RESCHEDULE_SIMULATION_SUCCESS, RESCHEDULE_TASK_SUCCESS, CLEAR_RESCHEDULE_SIMULATION].includes(
          action.type
        ),
      (state) => {
        state = false;
        return state;
      }
    );
});

export default combineReducers({
  tasks,
  simulationChanged,
});
